import { __read } from "tslib";
import React, { useState } from 'react';
export var QuantityInput = function (props) {
    var quantity = props.quantity, available = props.available, itemId = props.itemId, blocked = props.blocked, idx = props.idx, handleKeyDown = props.handleKeyDown, handleOnFocus = props.handleOnFocus, handeClick = props.handeClick, soldOut = props.soldOut, showQuantity = props.showQuantity, orderHeader = props.orderHeader;
    var _a = __read(useState(quantity), 2), value = _a[0], setValue = _a[1];
    var handleChange = function (event) {
        if (Number(event.target.value) || event.target.value === '' || !event.target.value || +event.target.value === 0) {
            var quantity_1 = event.target.value > available ? available : event.target.value;
            props.updateChanges(itemId, quantity_1);
            setValue(quantity_1);
        }
    };
    var convertAvailable = function (available, quantity) {
        var availability = 0;
        var realAvailable = +available;
        if (realAvailable > 0) {
            availability = realAvailable - +quantity;
        }
        return availability;
    };
    var showAvailable = function (available, quantity) {
        if (available === 9999) {
            return (React.createElement("span", { className: "quantity-grid__availability" },
                React.createElement("div", { className: "infiniteAvailability" })));
        }
        if (!showQuantity && !blocked && !soldOut && convertAvailable(available, value) !== 9999) {
            return (React.createElement("span", { className: 'quantity-grid__availability' + (convertAvailable(available, value) <= 0 ? ' zero' : '') },
                "(",
                convertAvailable(available, value),
                ")"));
        }
        return React.createElement(React.Fragment, null,
            !blocked && !soldOut && convertAvailable(available, value) > -1 && convertAvailable(available, value) < 6 &&
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "quantity-grid__availability" },
                        "(",
                        convertAvailable(available, value),
                        ")",
                        React.createElement("div", { className: "lowAvailability" }))),
            !blocked && !soldOut && convertAvailable(available, value) > 5 && convertAvailable(available, value) < 16 &&
                React.createElement("span", { className: "quantity-grid__availability" },
                    React.createElement("div", { className: "mediumAvailability" })),
            !blocked && !soldOut && convertAvailable(available, value) > 15 &&
                React.createElement("span", { className: "quantity-grid__availability" },
                    React.createElement("div", { className: "infiniteAvailability" })));
    };
    var renderInput = function () {
        return React.createElement(React.Fragment, null,
            !blocked && !soldOut &&
                React.createElement("input", { className: "quantity-input__input", type: "text", id: 'size_' + itemId, name: 'size_' + itemId, value: value, onChange: handleChange, 
                    // onKeyUp={handleKeyUp}
                    onKeyDown: handleKeyDown, onFocus: handleOnFocus, onClick: handeClick }),
            showAvailable(available, value),
            blocked &&
                React.createElement("span", { className: "quantity-input__label" }, "Blocked"),
            soldOut && !blocked &&
                React.createElement("span", { className: "quantity-input__label" }, "Sold Out"));
    };
    if (props.regularDiv) {
        return (React.createElement("div", { className: "quantity-grid__cell quantity-grid__item" }, renderInput()));
    }
    return (React.createElement("td", { className: "quantity-grid__cell quantity-grid__item", tabIndex: idx }, renderInput()));
};
//# sourceMappingURL=QuantityInput.js.map